<template>
  <div class="seniorInput">
    <div class="input-show-box">
      <div class="radio-box">
        <el-select v-model="searchRelation" class="fl">
          <el-option label="并且" :value="1"></el-option>
          <el-option label="或者" :value="0"></el-option>
        </el-select>
      </div>
      <div class="input-name">
        <el-select class="query-select" v-model="searchName" placeholder="请选择" @change="changeInput(1)">
          <el-option
            v-for="option in searchList"
            :key="option.englishName"
            :label="option.name"
            :value="option.englishName">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-input class="input-text" v-model="searchValue" type="text" :name="item.englishName"
                  @change="changeInput(1)"/>
      </div>
      <div class="input-like" v-show="false">
        <el-select v-model="searchType" placeholder="请选择">
          <el-option label="精确" value="1"></el-option>
          <el-option label="模糊" value="0" checked></el-option>
        </el-select>
      </div>
    </div>
    <div class="radio-box">
      <el-select v-model="searchRelationCopy" class="fl" @change="changeInput(2)">
        <el-option label="并且" :value="1"></el-option>
        <el-option label="或者" :value="0"></el-option>
      </el-select>
    </div>
    <div>
      <el-input class="input-text" v-model="searchValueCopy" type="text" :name="item.englishName"
                @change="changeInput(2)"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "seniorInput",
    props: {
      item: Object,
      searchList: Array,
      searchIndex: Number
    },
    data() {
      return {
        searchName: '',
        searchType: '0',
        searchRelation: 1,
        searchRelationCopy: 1,
        searchValue: '',
        searchValueCopy: '',
      }
    },
    methods: {
      getName() {
        this.searchName = this.searchList[this.searchIndex].englishName
      },
      //监听检索项
      changeInput(e) {
        let val = {
          searchName: this.searchName,
          searchType: 0,
          searchRelation: e == 1 ? this.searchRelation : this.searchRelationCopy,
          searchValue:  e == 1 ? this.searchValue : this.searchValueCopy,
          copy: e
        }
        this.$emit("changeInput", val)
      },
    },
    created() {
      this.getName()
    }
  }
</script>

<style lang="less" scoped>

  .seniorInput {
    float: left;
    display: flex;
    margin-top: 10px;

    div {
      float: left;
    }

    .el-select {
      margin-left: 5px;
    }

    /deep/ .input-name .el-input__inner {
      width: 150px;
      border: none;
      line-height: 36px;
    }

    /deep/ .input-like .el-input__inner {
      width: 80px;
      border: none;
      line-height: 36px;
    }

    .input-like {
      height: 32px;
    }

    .input-text {
      width: 400px;
      border: none;
      margin-left: 5px;
    }

    .radio-box {
      width: 100px;
    }

    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: #990000;
    }

    /deep/ .el-radio__input.is-checked .el-radio__inner {
      border-color: #990000;
      background: #990000;
    }
  }

</style>
